var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSiren = function SvgSiren(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 241h61v30H0zM451 241h61v30h-61zM383.277 107.512 425.7 65.09 446.91 86.3l-42.422 42.423zM107.508 128.719 65.086 86.297l21.21-21.211 42.423 42.422zM241 0h30v61h-30zM121 452c-16.57 0-30 13.43-30 30v30h330v-30c0-16.57-13.43-30-30-30zM121 256v166h270V256c0-74.441-60.559-135-135-135s-135 60.559-135 135m120-45h30v90h-30zm0 120h30v30h-30zm0 0"
  })));
};
export default SvgSiren;